const Header = () => {
  return (
    <div className='header'>
      <span id='heading'>Amazon Best Sellers</span>
      <span id='subheading'>
        Our most popular products based on sales. Updated frequently
      </span>
    </div>
  );
};
export default Header;
